import { Flex } from '@chakra-ui/react';
import ProtectedAction from '../ProtectedAction';
import { Button } from '@morressier/alembic';

interface ReviewerFooterProps {
  reviewId: string;
  onClickEvent: () => void;
  isDisabled: boolean;
}

const ReviewerFooter = ({
  reviewId,
  onClickEvent,
  isDisabled
}: ReviewerFooterProps) => {
  return (
    <Flex
      zIndex={1}
      position="fixed"
      bottom={0}
      width="100%"
      padding={4}
      bg="surfacePrimaryFill"
      justifyContent="center"
    >
      <Flex width="100%" maxWidth="100%" justifyContent="flex-end" gap={4}>
        <ProtectedAction
          relation="canReview"
          entityType="review"
          entityId={reviewId}
        >
          <Button
            variant="secondary"
            onClick={onClickEvent}
            disabled={isDisabled}
          >
            Save Draft
          </Button>
        </ProtectedAction>

        <ProtectedAction
          relation="canReview"
          entityType="review"
          entityId={reviewId}
        >
          <Button
            variant="primary"
            type="submit"
            form="review-form"
            disabled={isDisabled}
          >
            Submit Review
          </Button>
        </ProtectedAction>
      </Flex>
    </Flex>
  );
};

export default ReviewerFooter;
